import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDHz9_u6mZp_1KQh5AhLrNxnQ3Sqoa3tL4",
  authDomain: "online-book-store-300219.firebaseapp.com",
  projectId: "online-book-store-300219",
  storageBucket: "online-book-store-300219.appspot.com",
  messagingSenderId: "684368457232",
  appId: "1:684368457232:web:34fec9bf832bf79fbbe495",
  measurementId: "G-9T67XZ9NKS",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
